import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ref, onValue } from "firebase/database";
import { db } from "../firebaseConfig";
import styled from "styled-components";

const Container = styled.div`
  padding: 20px;
  text-align: center;
`;

const ProductImage = styled.img`
  max-width: 400px;
  width: 100%;
  border-radius: 12px;
`;

const Title = styled.h2`
  margin: 20px 0 10px;
  color: #0a2df3;
`;

const Description = styled.p`
  color: #555;
  font-size: 16px;
`;

const BuyButton = styled.button`
  margin-top: 15px;
  padding: 10px 20px;
  background: linear-gradient(45deg, #6a11cb, #2575fc);
  color: white;
  border: none;
  border-radius: 12px;
  cursor: pointer;
`;

const ProductPage = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const productRef = ref(db, `cards/${id}`);
    onValue(productRef, (snapshot) => {
      const data = snapshot.val();
      if (data) setProduct(data);
    });
  }, [id]);

  if (!product) return <Container>Loading...</Container>;

  return (
    <Container>
      <ProductImage src={product.url} alt={product.title} />
      <Title>{product.title}</Title>
      <Description>{product.description}</Description>
      <BuyButton onClick={() => window.open(product.buyUrl, "_blank")}>
        Buy Now
      </BuyButton>
    </Container>
  );
};

export default ProductPage;
